import { Tags } from "./TagCatalog";

export const AgricultureTagGroups = {
  humidityLayers: [
    Tags.Agriculture.SoilHumidityLayer1,
    Tags.Agriculture.SoilHumidityLayer2,
    Tags.Agriculture.SoilHumidityLayer3,
    Tags.Agriculture.SoilHumidityLayer4,
    Tags.Agriculture.SoilHumidityLayer5,
  ],
  temperatureLayers: [
    Tags.Agriculture.SoilTemperatureLayer1,
    Tags.Agriculture.SoilTemperatureLayer2,
    Tags.Agriculture.SoilTemperatureLayer3,
    Tags.Agriculture.SoilTemperatureLayer4,
    Tags.Agriculture.SoilTemperatureLayer5,
  ],
} as const;
